import { artistPageLoad } from '#lib/websites/artists/pages/ArtistDetailPage/utils/artistDetailsPageLoad/artistDetailsPageLoad.ts';

export const load = artistPageLoad;
